define((require) => {
    "use strict";

    const Permissions = require("shared/security/Permissions");

    return {
        _isFixedUser(user, entityCreator) {
            const isManager = user.get("role") === Permissions.Roles.MANAGER.name;
            const isEntityCreator = user.get("id") === entityCreator;
            return isManager || isEntityCreator;
        },

        mapUsersToFixedDropdownValues(users, entityCreator) {
            const fixedDropdownValues = users
                .filter((user) => {
                    return this._isFixedUser(user, entityCreator);
                })
                .map((user) => {
                    return {
                        value: user.get("id"),
                        label: user.get("name"),
                        isSelected: true
                    };
                });
            return fixedDropdownValues;
        },

        mapUsersToDropdownValues({usersInCompany, entitySharedUsers, entityCreator}) {
            const dropdownValues = usersInCompany
                .filter((user) => {
                    return !this._isFixedUser(user, entityCreator);
                })
                .map((user) => {
                    const isEntitySharedWithUser = entitySharedUsers.indexOf(user.get("id")) !== -1;
                    return {
                        value: user.get("id"),
                        label: user.get("name"),
                        isSelected: isEntitySharedWithUser
                    };
                });
            return dropdownValues;
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/experienceOverview/experiencePermissions/DropdownValueMapper.js